// extracted by css-extract-rspack-plugin
export default {"warnings":"q66hS"};